import { FiSearch } from 'react-icons/fi';

import styles from '@/admin/components/AdminSearchInput.module.scss';

type AdminSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export const AdminSearchInput = ({ value, onChange, placeholder }: AdminSearchInputProps) => (
  <div className={styles.wrapper}>
    <span className={styles.icon}>
      <FiSearch />
    </span>
    <input
      className={styles.input}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder ?? 'Search…'}
    />
  </div>
);
